import Api from "..";
import TransmedReceiving, {
  TransmedReceivingInput,
} from "../../dtos/transmed/process/receiving";
import transform from "../../service/transform";

export default class TransmedReceivingApi extends Api {
  constructor() {
    super("transmed/receiving");
  }

  public async get(): Promise<TransmedReceiving[]> {
    const data = (await super.get()).data;
    if (!Array.isArray(data))
      throw new TypeError("TransmedReceiving entry list is not an array.");

    return await Promise.all(
      data.map(async (value) => await transform(TransmedReceiving)(value))
    );
  }

  public async post(data: TransmedReceivingInput): Promise<TransmedReceiving> {
    return await transform(TransmedReceiving)((await super.post(data)).data);
  }

  public async put(
    id: string,
    data: TransmedReceivingInput
  ): Promise<TransmedReceiving> {
    return await transform(TransmedReceiving)((await super.put(id, data)).data);
  }

  public async delete(id: string): Promise<void> {
    await super.delete(id);
  }
}
